import { call } from "redux-saga/effects";
import {
  IGetPresignedUrlResponse,
  IUploadFileParams,
} from "../../interfaces/files/files";
import { getPresignedUrlApi, uploadFileApi } from "../../api/files";

export function* uploadImage(
  imageData: IUploadFileParams,
  userId: string,
  uuid?: string
) {
  try {
    const imagePresignedUrl: { data: IGetPresignedUrlResponse } = yield call(
      getPresignedUrlApi,
      {
        filePath: userId,
        fileName: (uuid || "") + imageData.fileName,
        fileType: imageData.fileType,
      }
    );

    yield call(uploadFileApi, {
      presignedUrl: imagePresignedUrl.data.url,
      binaryFile: imageData.binaryFile,
    });
  } catch (error: any) {
    console.error("Error in uploadImage: ", error);
    throw new Error("Error in uploadImage");
  }
}
